import { createContext, useState, useRef, useEffect } from "react"
import { getDefaultLanguage } from "../lib/utils"
import dlv from "dlv"
import tmpl from "templite"
import { useRouter } from "next/router"

function rosetta(obj) {
	var locale = "",
		tree = obj || {}

	return {
		set(lang, table) {
			tree[lang] = Object.assign(tree[lang] || {}, table)
		},

		locale(lang) {
			return (locale = lang || locale)
		},

		table(lang) {
			return tree[lang]
		},

		t(key, params, lang) {
			const activeLocale = lang || locale
			let val = dlv(tree[activeLocale], [key])
			const isMissing = val === undefined

			if (isMissing && typeof key === "string") {
				val = key.startsWith("Nx:") ? key.slice(3) : key
			} else if (isMissing) {
				val = key
			}

			if (typeof val === "function") return val(params)
			if (typeof val === "string") return tmpl(val, params)
			return val
		},
	}
}

const i18n = rosetta()
export const defaultLanguage = getDefaultLanguage()

export const I18nContext = createContext()

// default language
i18n.locale(defaultLanguage)

export const I18nProvider = ({ children, locale, lngDict }) => {
	const router = useRouter()
	const activeLocaleRef = useRef(locale || defaultLanguage)
	const [, setTick] = useState(0)
	const firstRender = useRef(true)

	const i18nWrapper = {
		activeLocale: activeLocaleRef.current,
		t: (...args) => {
			if (router?.query?.debugI18n) {
				return "[" + args[0] + "]"
			}
			return i18n.t(...args) || args[0]
		},
		locale: (l, dict) => {
			i18n.locale(l)
			activeLocaleRef.current = l
			if (dict) {
				i18n.set(l, dict)
			}
			// force rerender to update view
			setTick((tick) => tick + 1)
		},
	}

	// for initial SSR render
	if (locale && firstRender.current === true) {
		firstRender.current = false
		i18nWrapper.locale(locale, lngDict)
	}

	// when locale is updated
	useEffect(() => {
		if (locale) {
			i18nWrapper.locale(locale, lngDict)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lngDict, locale])

	return <I18nContext.Provider value={i18nWrapper}>{children}</I18nContext.Provider>
}
